<script lang="ts">
  import { Checkbox, FormGroup } from "carbon-components-svelte";
  import { TextBold } from "carbon-icons-svelte";
  import Icon from "./Icon.svelte";
  export let group: string[];
  export let values: string[];
</script>

<FormGroup legendText="Style" noMargin class="flex-wrap">
  {#each values as value}
    <div class="flex-with-icon">
      <Checkbox bind:group labelText={value} {value} />
      <Icon {value} />
    </div>
  {/each}
</FormGroup>
